<div class="update-toaster">
  <h1>Update now to get the latest version ✨</h1>
  <ion-button color="secondary">Update</ion-button>
</div>
